import { memo, useState } from "react";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import React from "react";

function ProfilePictureDisplayer({
  profilePicture,
  onClick,
  width,
  height,
  userAccountType,
  userUid,
  margin,
}: {
  profilePicture: string;
  onClick: Function;
  width: string;
  height: string;
  userAccountType: "personal" | "business";
  userUid: number | null | undefined;
  margin: string | null;
}) {
  const theme: "light" | "dark" = useThemeHook();
  const [isOnline, setIsOnline] = useState(false);

  return (
    <>
      <div
        style={{
          minWidth: width,
          minHeight: height,
          width: width,
          height: height,
          padding: "0px",
          position: "relative",
          borderRadius: "50%",
          marginLeft: margin ?? 0,
        }}
      >
        <img
          style={{
            objectFit: "cover",
            backgroundColor: THEME_COLORS[theme].less_theme,
            width: "100%",
            height: "100%",
            borderRadius: userAccountType === "personal" ? "50%" : "10px",
          }}
          loading="lazy"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          src={profilePicture}
          alt=""
        />
        {isOnline === true && (
          <div
            style={{
              position: "absolute",
              bottom: "0px",
              right: "0px",
              height: "15px",
              width: "15px",
              borderRadius: "50%",
              backgroundColor: "green",
              border: "3px solid " + THEME_COLORS[theme].full_theme,
            }}
          ></div>
        )}
      </div>
    </>
  );
}
export default memo(ProfilePictureDisplayer);
